export class OpcoesGestorInvitePaginado {
    constructor(
        public offset: number,
        public pageSize: number,
        public nome: string,
        public cpf: string,
        public email: string,
        public status: string,
        public validade: Date,
        public search: string
    ) { }
}
